import { useState } from 'react';
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Box, Chip } from "@mui/material"; // or "../../../imports/muiImport"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

function ProductDetailPara({ productDescription }) {
    const [showMore, setShowMore] = useState(false);

    // Word limit for collapsed state
    const wordLimit = 40;

    // Trimmed version of the description
    const trimmedDescription = productDescription
        ?.split(' ')
        .slice(0, wordLimit)
        .join(' ') + '...';

    const shouldTrim = productDescription?.split(' ').length > wordLimit;

    return (
        <>
            <Box
                sx={{
                    fontSize: "1.125rem",
                    lineHeight: 1.7,
                    color: "text.primary",
                    fontFamily: "inherit",
                    "& table": {
                        borderCollapse: "collapse",
                        width: "100%",
                        mt: 2,
                    },
                    "& th, & td": {
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "justify",
                    },
                    "& ul, & ol": {
                        paddingLeft: "20px",
                        marginBottom: "1em",
                    },
                    "& a": {
                        color: "primary.main",
                        textDecoration: "underline",
                        wordBreak: "break-word",
                        fontSize: "1rem",
                        lineHeight: 1.6,
                        fontWeight: 400,
                        display: "inline",
                        verticalAlign: "baseline",
                        textAlign: "justify",
                        letterSpacing: "0.25px",
                    },
                    "& p": {
                        textAlign: "justify",
                    }
                }}
            >
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {showMore || !shouldTrim ? productDescription : trimmedDescription}
                </ReactMarkdown>
            </Box>

            {shouldTrim && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Chip
                        label={showMore ? "Show less" : "Show more"}
                        onClick={() => setShowMore(prev => !prev)}
                        icon={showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        sx={{ mb: 2, cursor: "pointer" }}
                        color="primary"
                        variant="outlined"
                    />
                </Box>
            )}
        </>
    );
}

export default ProductDetailPara;
